export default {
    namespaced: true,
    state: {
        program: null,
        googleApiKey: null,
        settings: {}
    },
    mutations: {
        SET_PROGRAM: (state, program) => {
            state.program = program;
            state.settings = program.settings;
        },
        SET_GOOGLE_API_KEY: (state, key) => state.googleApiKey = key,
    },
    actions: {
        setProgram: ({commit}, program) => commit('SET_PROGRAM', program),
        setGoogleApiKey: ({commit}, key) => commit('SET_GOOGLE_API_KEY', key),
    },
    getters: {},
}
